import { Trash2 } from 'lucide-react';
import { IconTooltip } from './IconTooltip';
import styles from './TrashIconButton.module.css';

interface TrashIconButtonProps {
  tooltip: string;
  label: string;
  disabled: boolean;
  onClick: () => void;
}

export const TrashIconButton = ({ tooltip, label, disabled, onClick }: TrashIconButtonProps) => (
  <IconTooltip label={tooltip}>
    <button
      type="button"
      className={styles.trashIconButton}
      disabled={disabled}
      aria-label={label}
      onClick={onClick}>
      <Trash2 aria-hidden="true" />
    </button>
  </IconTooltip>
);
